"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_router_dom_1 = require("react-router-dom");
var useConfigurableStyle_1 = require("../../_utils/useConfigurableStyle");
var LeftnavItem = function (_a) {
    var _b;
    var active = _a.active, className = _a.className, overrideDefaultClassName = _a.overrideDefaultClassName, iconFaClass = _a.iconFaClass, isLinkTo = _a.isLinkTo, labelText = _a.labelText, autoActivateWithLink = _a.autoActivateWithLink, props = __rest(_a, ["active", "className", "overrideDefaultClassName", "iconFaClass", "isLinkTo", "labelText", "autoActivateWithLink"]);
    var finalClassName = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: {
            "leftnav__item": !active,
            "leftnav__item--active": active,
        },
        additionalClassName: className,
        overrideDefaultClassName: overrideDefaultClassName
    })[0];
    var iconClassName = classnames_1.default((_b = {
            "leftnav__item__icon": true
        },
        _b[iconFaClass + ""] = typeof iconFaClass === "string",
        _b));
    var InnerNavItem = typeof isLinkTo === "string" ? (function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (react_1.default.createElement(react_router_dom_1.NavLink, __assign({ to: isLinkTo, className: finalClassName, activeClassName: autoActivateWithLink ? "leftnav__item--active" : "" }, props), children));
    }) : (function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (react_1.default.createElement("div", __assign({ className: finalClassName }, props), children));
    });
    return (react_1.default.createElement(InnerNavItem, __assign({ className: finalClassName }, props),
        react_1.default.createElement("i", { className: iconClassName }),
        react_1.default.createElement("div", { className: "leftnav__item__label" }, labelText)));
};
LeftnavItem.defaultProps = {
    iconFaClass: "fas fa-circle"
};
exports.default = LeftnavItem;
